import React from 'react';
import { loadMockFeedResult } from './mockFeed';

// The localhost-only fixture path, kept out of useFeedView.
//
// `runMock` used to live in useFeedView, which meant an unguarded top-level
// `import { loadMockFeedResult } from './mockFeed'` — 385 lines of literal fixture data — in the
// import graph of everything that reads a feed. mockFeed's own header claimed "nothing imports it in
// a deployed path", which was false as written: the only gate was a RENDER gate on the form's
// localhost branch, and nothing in the build excluded it.
//
// This does not remove it from the bundle — that needs a dynamic import, which would make runMock
// async and force an await into every useFeedView.test.js call site. What it does is stop the fixture
// being a dependency of reading a feed: useFeedView is now fixture-free, and the fixture is one
// hook that one page composes.
//
// It goes through the same normalization and the same result state as a live read, so what is on
// screen is exercised code rather than a parallel rendering path — which is the whole point of
// having it.
export const useMockFeedView = (present) =>
  React.useCallback(
    // forgetLastRun: a fixture has no params to retry, so it must not leave a real feed's request
    // sitting behind a Try again button.
    (options) => present(loadMockFeedResult(options), { forgetLastRun: true }),
    [present]
  );
